export class Model {
    assign(data = {}): void {
        Object.assign(this, data);
    }
}
